import React from 'react';
import AdminOrderBreakdown from '../components/Admin/AdminOrderBreakdown';

const AdminOrderBreakdownPage = () => {
  return <AdminOrderBreakdown />;
};

export default AdminOrderBreakdownPage;